export enum ButtonStyleEnum {
  'purple' = 'purple',
  'orange' = 'orange',
  'outline' = 'outline',
  'gray' = 'gray',
  'peach' = 'peach',
  'light-peach' = 'light-peach',
}

export enum ButtonSizeEnum {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}
